import React, { useEffect, useState } from "react";
import { Form, Input, Button, Flex, ColorPicker, message,Row , Col } from "antd";
import { CreateTeam, UpdateTeam } from "../../api's/settings.js";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext.js";
import { CustomInput, CustomTitle } from "../../components";
import CustomButton from "../../components/CustomButton.jsx";

const TeamForm = ({ teamData, onClose, refreshTeams }) => {
  const [form] = Form.useForm();
  const { token } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const isEditing = !!teamData;
  const [color, setColor] = useState(teamData?.color || "#000000");

  useEffect(() => {
    if (teamData) {
      form.setFieldsValue({ name: teamData.name });
      setColor(teamData.color || "#000000");
    } else {
      form.resetFields();
      setColor("#000000");
    }
  }, [teamData, form]);
  const onFinish = async (values) => {
    const newTeam = { ...values, color };
    showSpin();
    try {
      let response;
      if (isEditing) {
        let model = { ...newTeam, id: teamData?.id }
        response = await UpdateTeam(token, model);
      } else {
        response = await CreateTeam(token, newTeam);
      }
      if (response?.data?.data?.is_success) {
       // message.success(response.data.data.message);
       message.success("Team added successfully!");
        refreshTeams();
        form.resetFields();
        setColor('#000000')
        onClose();
      } else {
        message.error(response.data.data.message || "Failed to save team");
      }
    } catch (error) {
      message.error("An error occurred. Please try again.");
      console.error("API Error:", error);
    } finally {
      hideSpin();
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      <div
        style={{
          position: "absolute",
          top: "40px",
          paddingTop: "0px",
          left: "0",
          padding: "0px 32px",
          width: "100%",
          background: "#fff",
          zIndex: "2",
        }}
      >
        <CustomTitle
          text={isEditing ? "Edit team" : "Add team"}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />
      </div>
      {/* <div style={{ flex: 1, overflowY: "auto", paddingBottom: "80px" }}>
        <h2
          style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}
        >
          {isEditing ? "Edit team" : "Add team"}
        </h2> */}
      <div
        style={{
          flex: 1,
          // overflowY: "auto",
          paddingBottom: "130px",
          paddingTop: "16px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="custom-scrollbar"
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="name"
             className="custom-input form-input-style"
              rules={[{ required: true, message: "Please enter a team name" }]}
            >
              <CustomInput
                placeholder="Enter team name"

              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item     className="custom-input form-input-style" label="Color" style={{ marginTop: "0px" }}>
              <Flex gap={16} align="center">
                <ColorPicker
                  value={color}
                  showText
                  format="hex"
                  onChange={(newColor) => setColor(newColor.toHexString())}
                />
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    backgroundColor: color,
                    borderRadius: "50%",
                    border: "1px solid #ddd",
                  }}
                ></div>
              </Flex>
            </Form.Item>
          </Col>

        </Row>







        <div
          style={{
            background: "#fff",
            position: "absolute",
            bottom: "0",
            left: "0",
            width: "100%",
            padding: "0 24px 24px",
          }}
        >
           <Row gutter={[0, 8]} style={{ marginTop: "0" }}>
          <CustomButton
            key="button1"
            text="Save"
            bgColor="#000"
            htmlType="submit"
            color="#fff"
            fontSize="16px"
            fontWeight="600"
            boxShadow="none"
            height="48px"
            width="100%"
          />

          <CustomButton
            key="button2"
            text="Cancel"
            bgColor="transparent"
            color="#000"
            fontSize="16px"
            fontWeight="600"
            boxShadow="none"
            height="auto"
            width="100%"
            padding={'11.5px 0px 12px 0px'}
            border="none"
            marginTop="0px"
  
            onClick={onClose}
          />
          </Row>
        </div>
      </div>
    </Form>
  );
};

export default TeamForm;
